import React from "react";
import "../scss/common.scss";

function AnalyticsSidebar() {
  return (
    <div className="sidebar">
      <details name="aco1">
        <summary>経費関連</summary>
        <ul className="inner">
          <a href="">
            <li>リンク1</li>
          </a>
          <a href="">
            <li>リンク2</li>
          </a>
          <a href="">
            <li>リンク3</li>
          </a>
        </ul>
      </details>
      <details name="aco2">
        <summary>スタジオ別売上一覧</summary>
        <ul className="inner">
          <a href="">
            <li>リンク4</li>
          </a>
          <a href="">
            <li>リンク5</li>
          </a>
          <a href="">
            <li>リンク6</li>
          </a>
        </ul>
      </details>
    </div>
  );
}

export default AnalyticsSidebar;
